import React, { useState } from 'react';

const STEPS = [
  {
    label: 'Totality (Ω)',
    icon: '◯',
    desc: 'Everything that could ever be experienced — already here, like every frame of a film already on the disc.',
  },
  {
    label: 'Your Lens',
    icon: '◎',
    desc: 'Body, senses, narrative, intent — these shape the aperture. Like a camera opening, they determine what gets through.',
  },
  {
    label: 'Pressure',
    icon: '◈',
    desc: 'The mismatch between what flows and what fits. Not danger — just load. A garden hose through a pinhole.',
  },
  {
    label: 'Experience',
    icon: '◇',
    desc: 'What you actually feel. Clarity, intensity, overwhelm, or dissolution — all from the same field, through different apertures.',
  },
  {
    label: 'Events',
    icon: '✦',
    desc: 'Possibilities that emerge from the gradient — the field gently suggesting where coherence could increase.',
  },
  {
    label: 'Residue',
    icon: '∿',
    desc: 'What didn\'t integrate echoes forward. Like ripples after a stone — not punishment, just physics.',
  },
];

const HowItWorks = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="how-it-works">
      <button
        className="how-it-works-toggle"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? '▾' : '▸'} How this works
      </button>

      {expanded && (
        <div className="how-it-works-content">
          <div className="how-it-works-flow">
            {STEPS.map((step, i) => (
              <div key={step.label} className="how-it-works-step">
                <div className="how-it-works-icon">{step.icon}</div>
                <div className="how-it-works-label">{step.label}</div>
                <div className="how-it-works-desc">{step.desc}</div>
                {i < STEPS.length - 1 && <div className="how-it-works-arrow">↓</div>}
              </div>
            ))}
          </div>
          <p className="how-it-works-note">
            Nothing in this chain judges, prescribes, or predicts. It simply shows
            why the same reality can feel completely different through different lenses.
          </p>
        </div>
      )}
    </div>
  );
};

export default HowItWorks;
